import React, { useEffect, useState } from "react";
import { getAssetsCount } from "../../services/trackService";
import { GetAssetCountResponse } from "../../proto/api_pb";
import { AssetCountProps } from "./types";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";

const AssetCount: React.FC<AssetCountProps> = ({
    projectId,
    folderId,
    isCountUpdated,
    setIsCountUpdated
}) => {
    const [tracksCount, setTracksCount] = useState<number | null>(null);
    const [filesCount, setFilesCount] = useState<number | null>(null);
    const { getValidAccessToken } = useGetValidAccessToken()

    useEffect(() => {
        const getAssetCount = async () => {
            try {
                const token = await getValidAccessToken();
                const response = await getAssetsCount(token, projectId, folderId);
                if (response instanceof GetAssetCountResponse) {
                    setTracksCount(response.getTracksCount());
                    setFilesCount(response.getFilesCount());
                } else {
                    setTracksCount(null);
                    setFilesCount(null);
                }
            } catch (error) {
                console.error("Error fetching track count:", error);
                setTracksCount(null);
                setFilesCount(null);
            }
        };

        getAssetCount();
        if (isCountUpdated && setIsCountUpdated) {
            setIsCountUpdated(false);
        }
    }, [getValidAccessToken, projectId, folderId, isCountUpdated, setIsCountUpdated]);

    if (tracksCount === null || filesCount === null) return null;
    if (tracksCount === 0 && filesCount === 0) return null

    return (
        <span style={{ fontSize: "1.3rem", fontWeight: "normal" }}>
            {tracksCount > 0 || filesCount > 0 ? (
                <span>
                    ({tracksCount > 0 ? `${tracksCount} Track${tracksCount > 1 ? 's' : ''}` : ''}
                    {tracksCount > 0 && filesCount > 0 ? ' ' : ''}
                    {filesCount > 0 ? `${filesCount} File${filesCount > 1 ? 's' : ''}` : ''})
                </span>
            ) : null}
        </span>
    );
};

export default AssetCount;
